import { ApiResponse, ErrorWithMessage } from '../types';
import { ApiClient } from '../client/ApiClient';

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string'
  );
}

export function getErrorResponse(maybeError: unknown): ApiResponse<any> {
  if (isErrorWithMessage(maybeError)) return { error: maybeError, statusCode: ApiClient.errorCodes.network };

  const statusCode = typeof maybeError === 'number' ? maybeError : ApiClient.errorCodes.network;

  try {
    return { error: new Error(JSON.stringify(maybeError)), statusCode };
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return { error: new Error(String(maybeError)), statusCode };
  }
}
